$(() => {
  if ($('.master_activity-review-editing')) {
    const reviewEditing = {
      setup() {
        this.eventHandlers();
      },

      eventHandlers() {
        const _this = this;

        $('select#assignee_id').change(function () {
          _this.setValue.call(this, '#master_activity_assignee_id');
        });

        $('#review_date').change(function () {
          _this.setValue.call(this, '#master_activity_review_date');
        });

        $('#default-review-date').click(() => {
          $('#review_date').datepicker('update', $('#default_date').val());
        });

        $('#snapshot_comment_input').change(function () {
          _this.setValue.call(this, '#snapshot_comment');
        });
      },

      setValue(selector) {
        $(selector).val($(this).val());
      },
    };

    reviewEditing.setup();
  }
});
